import type { CheckoutCartHistoryItem, CheckoutKiosk } from '@gozoki/api-types'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchCheckoutKiosks, fetchRecentCheckoutCarts } from '../queries/checkoutKiosk.queries'
import { checkoutKiosksQueryKey } from '../queries/keys'

const checkoutStaleTime = (refetchInterval: number | false): number =>
  typeof refetchInterval === 'number'
    ? Math.min(Math.max(refetchInterval - 1000, 4000), 30_000)
    : 30_000

// Définie avec les autres clés de cache (`queries/keys`) ; ré-exportée ici pour le barrel
// `@gozoki/api` et les imports existants du BO.
export { checkoutKiosksQueryKey }

export const useCheckoutKiosks = (
  storeId: number,
  enabled = true,
  refetchInterval: number | false = 5000,
): UseQueryResult<CheckoutKiosk[], unknown> =>
  useQuery({
    queryKey: checkoutKiosksQueryKey(storeId),
    queryFn: () => fetchCheckoutKiosks(storeId),
    enabled,
    refetchInterval,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: checkoutStaleTime(refetchInterval),
  })

export const useRecentCheckoutCarts = (
  storeId: number,
  enabled = true,
  refetchInterval: number | false = 5000,
): UseQueryResult<CheckoutCartHistoryItem[], unknown> =>
  useQuery({
    queryKey: [...checkoutKiosksQueryKey(storeId), 'recent-carts'],
    queryFn: () => fetchRecentCheckoutCarts(storeId),
    enabled,
    refetchInterval,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: checkoutStaleTime(refetchInterval),
  })
